import { NavLink } from 'react-router-dom';
import '../styles/MobileMenu.scss';

type MenuItem = {
  id: string;
  title: string;
  navLink: string;
};

type MobileMenuProps = {
  menuItems: Array<MenuItem>;
  onItemClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const MobileMenu: React.FC<MobileMenuProps> = (props) => {
  return (
    <div className="mobile-menu">
      <ul>
        {props.menuItems.map((menu) => (
          <li key={menu.id}>
            <NavLink
              key={menu.id}
              className="popup-menu-item"
              to={menu.navLink}
              data-id={menu.id}
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.6,
              })}
              onClick={props.onItemClick}
            >
              {menu.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileMenu;
